// apps/web/src/layouts/components/SidebarAnalystQueueBadge.tsx
//
// Badge da fila de análise. O número vem de `useSidebarBadgeCounts()`, montado
// uma vez no topo da sidebar admin, e é contextual ao usuário: analista conta as
// propostas atribuídas a si e ainda não iniciadas; quem não tem perfil de
// analista conta as propostas sem dono.

import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export interface SidebarAnalystQueueBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarAnalystQueueBadge({ count, variant }: SidebarAnalystQueueBadgeProps) {
  const { t } = useTranslation('admin');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-analyst-queue-badge"
      label={t('sidebar.badges.analysis_pending', { count })}
    />
  );
}
